<template>
    <IntegrationSettingsCard icon="fas fa-cogs"
                             title="Settings"
                             description="Manage general settings for the integration"
    >
        <template v-slot:body>
            <Alert v-if="!formData.zoho_organization_id"
                   class="mb-3"
                   :title="__('integrations.config_required')"
                   type="warning">
                <template v-slot:icon>
                    <i class="fas fa-exclamation-triangle"/>
                </template>
                {{ __('integrations.config_required_before_store_linking') }}
            </Alert>
            <div class="form-group">
                <label class="font-weight-bold">Zoho Organization</label>
                <select class="form-control" v-model="configs.zoho_organization_id">
                    <option :selected="configs.zoho_organization_id === null" disabled>
                        {{ __('actions.please_select') }}
                    </option>
                    <option v-for="(organizationName, organizationId) in formData.available_organizations"
                            :key="organizationId"
                            :value="organizationId"
                            :selected="configs.zoho_organization_id === organizationId"
                    >
                        [{{ organizationId}}] {{ organizationName }}
                    </option>
                </select>
                <span class="form-text text-muted">Select the ID that represents youbuyda.</span>
            </div>

            <div class="d-flex flex-row justify-content-end pt-2">
                <div>
                    <button class="btn btn-primary" :disabled="!configs.isDirty" @click="saveUserSettings">
                        <i class="fas fa-save"/>
                        {{ __('actions.submit') }}
                    </button>
                </div>
            </div>
        </template>
    </IntegrationSettingsCard>
</template>

<script>
import IntegrationSettingsCard from '../../../components/Integrations/IntegrationSettingsCard';
import IntegrationsSettingsLayout from '../../../layouts/IntegrationsSettingsLayout';
import Alert from '@components/Alert.vue';

export default {
    components: {Alert, IntegrationSettingsCard},
    layout: IntegrationsSettingsLayout,

    props: {
        integration: Object,
        formData: Object,
        stores: Array,
        enabledStores: Array,
    },

    data() {
        return {
            configs: this.$inertia.form(this.formData)
        }
    },

    methods: {
        saveUserSettings() {
            this.configs.post(this.$route('integration.config', [this.integration.code]));
        }
    }
};
</script>
